<template>
	<!-- 订单信息补充弹框 添加进度，申请协助 -->
	<common-modal :showClose="true" @close-modal="onCloseModalClick" class="supply-wrap">
		<div class="modal ">
		    <div class="title">{{objSupplyFollow.title}}</div>
		    <ul class="list-wrap che-dan">
	            <li>
	            	<textarea class="textarea" :rows="8" v-model="content" @blur="backHeight" :placeholder="objSupplyFollow.inputVal"/>
	            </li>
	            
	            <li class="admin-img no-b">
	            	<div class="num">上传图片（{{addImages.length }}/6）</div>
	            	<imageUpload v-model="addImages" :limit="6" class="add-img"/>
	            </li>
				
				<li class="notice-wrap no-b" v-if='objSupplyFollow.follow=="admin"'>
					<span class="notice" @click="noticeFlag=!noticeFlag" :class='noticeFlag?"on":"off"'></span>
					<span class="notice-on" >用户可见</span>
				</li>
				
		    </ul>

		    <div class="supply-submit">
				<span class="cancel" @click="onCloseModalClick">取消</span>
				<span class="submit" @click="submitSupplyAdd">确定</span>
			</div>
		</div>
	</common-modal>
</template>

<script>
	import imageUpload from './ImageUpload';
	import CommonModal from './CommonModal';
    export default {
        data(){
            return{
				addImages:[],
				content:"",
				noticeFlag:false
            }
        },
		props:{
			objSupplyFollow:{
				type:Object
			}
		},
		
        methods:{
			submitSupplyAdd(){
				if(!this.content){
					window.toast("请输入内容","txt");
					return;
				}
				let type="";
				this.noticeFlag?type=1:type=2
				this.$emit("submitSupplyAdd",this.content,JSON.stringify(this.addImages),this.objSupplyFollow.follow,type)
			},
			
			onCloseModalClick(){
				this.$emit("close-modal")
			},
			
			backHeight(){
			    setTimeout(() => {
			        const scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0;
			        window.scrollTo(0, Math.max(scrollHeight - 1, 0));
			    }, 100);
			}
        },
		components:{
			imageUpload,
			CommonModal
		}
        
    };
</script>
<style lang="less" scoped>
    @import '~@/assets/styles/variable.less';
    @import '~@/assets/styles/handleMethods.less';
    @import '~@/assets/styles/reset.css';
	section{font-family:PingFangSC-Regular;font-weight:400;background:#FFF}
	.modal{width: 320px;background: #fff;margin: 0 auto;padding-bottom: 20px;}
	.title{padding: 12px 20px 0 20px;font-size:18px;font-family:PingFangSC-Medium;font-weight:500;color:rgba(51,51,51,1);text-align: center;}
	
	/* 补充资料弹框 */
	.list-wrap{padding: 15px 15px 15px 15px;}
	.list-wrap li{margin-bottom: 10px}
	.list-wrap .no-b{margin-bottom: 0px}
	.textarea{width: 100%;height: 105px;padding: 10px;appearance: none;background:rgba(245,245,245,1);border-radius:2px;border:1px solid rgba(207,207,207,1);resize: none;outline: none;font-size:13px;font-family:PingFangSC-Regular;font-weight:400;color:rgba(153,153,153,1);}
	.done{background: url(../assets/images/home/pic_right2_pitchon.png) no-repeat center center;background-size:cover;}
	.undone{background: url(../assets/images/home/pic_right2_pitchoff.png) center center no-repeat;background-size: cover}
	.num{font-size:14px;font-family:PingFangSC-Regular;font-weight:400;color:rgba(20,20,20,1);margin-bottom: 12px}
	.supply-wrap /deep/ .modal{padding-bottom: 0;}
	.supply-submit{display: flex;align-items: center;justify-content: space-between;width: 100%;height: 49px;color: #ffffff;border-top: 1px solid #DDDDDD;}
	.supply-submit .cancel{width: 50%;height:49px;line-height: 49px;font-size: 18px;color: rgba(153,153,153,1);text-align: center;border-right: 1px solid #DDDDDD}
	.supply-submit .submit{width: 50%;height:49px;line-height: 49px;font-size: 18px;font-weight: 500;color: rgba(65,132,244,1);text-align: center;}
	
	.notice-wrap{display: flex;align-items: center;font-size:13px;font-family:PingFangSC-Regular,PingFang SC;font-weight:400;color:rgba(174,174,174,1);}
	.notice-on{display: inline-block;margin-right: 50px}
	.notice{width: 25px;height:15px;margin-right: 12px}
	.on{background: url(../assets/images/personal/pic_mine_on.png) no-repeat center center;background-size: 25px;}
	.off{background: url(../assets/images/personal/pic_mine_off.png) no-repeat center center;background-size: 25px;}
	
	// .follow-wrap{padding: 0 8px 0px 20px;}
	.follow-wrap  .follow-tag{display: inline-block;padding: 4px 8px 5px 4px;margin-bottom: 5px;border-radius:3px;border:1px solid rgba(174,174,174,1);color:rgba(174,174,174,1);font-weight:400;font-size: 12px;}
	.follow-wrap .current{border:1px solid rgba(65,132,244,0.5);background:rgba(65,132,244,0.1);color:rgba(65,132,244,1);}
	.follow-detail{padding-bottom: 10px;font-size:14px;font-family:PingFangSC-Regular,PingFang SC;font-weight:400;color:rgba(20,20,20,1);}
	.follow-detail span{font-size:12px;font-family:PingFangSC-Regular,PingFang SC;font-weight:400;color:rgba(174,174,174,1);}
</style>
